module.exports = __webpack_public_path__ + "img/step5-dark.a97050fb.png";